import { render, staticRenderFns } from "./SearchResultGroupedItem.vue?vue&type=template&id=583083f6&scoped=true"
import script from "./SearchResultGroupedItem.vue?vue&type=script&lang=ts"
export * from "./SearchResultGroupedItem.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultGroupedItem.vue?vue&type=style&index=0&id=583083f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583083f6",
  null
  
)

export default component.exports